import { FC } from 'react'
import { PastCardCheckbox } from 'components/features/future/FutureLayerPast/PastCardCheckbox/PastCardCheckbox'
import { formatUSCurrency } from 'helpers/formatHelpers'

type UpdateIncomeProps = {
  amount?: number
}
export const UpdateIncome: FC<UpdateIncomeProps> = (props) => {
  const { amount } = props

  return (
    <PastCardCheckbox
      name='set_income'
      label={ `Update your current income${ amount ? ` to ${ formatUSCurrency(amount) }` : `` }` }
    />
  )
}
